<template>
  <div class="text-center">
    <v-card>
      <v-alert type="error" v-if="creditError">{{errorMessage}}</v-alert>
      <v-container>
        <v-row justify="center" class="col-12">
          <v-col cols="12" align="center">
            <v-form
              ref="form"
              v-model="formValid"
            >
              <v-row class="col-12">
                <v-col cols="12">
                  <v-autocomplete
                    color="error"
                    label="Zvolte uživatele"
                    v-model="form.user"
                    :items="users"
                    item-text="name"
                    return-object
                    prepend-icon="mdi-account"
                    hide-selected
                    persistent-hint
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-row
                  cols="12"
                  v-if="hasCredit"
                ><v-col>
                  <v-textarea
                    v-model="form.comment"
                    label="Poznámka"
                    outlined
                    type="text"
                    prepend-icon="mdi-note"
                  >
                  </v-textarea>
                </v-col>
                  <v-col>
                    <v-text-field
                      prepend-icon="mdi-receipt"
                      v-model="form.amount"
                      label="Částka"
                      type="number"
                      ref="amount"
                      :disabled="form.all"
                      min="0"
                      :max="maxAmount"
                      outlined
                      :rules="[rules.number, rules.greaterThan(0), rules.lessThan(maxAmount+1)]"
                    ></v-text-field>
                    <v-checkbox
                    label="Vrátit všechny kredity"
                    v-model="form.all"
                    />
                  </v-col>
                </v-row>
                <v-col v-else-if="!!form.user.id">
                  Uživatel nemá žádný kredit.
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    ref="check"
                    v-model="dataChecked"
                    label="Souhlasím s vystavením dobropisu (tato akce nejde vrátit - uživateli se všechny kredity)"
                    :rules="[rules.checked]"
                    required
                    :disabled="!hasCredit"
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="12" class="text-right">
                  <v-btn
                    :disabled="!formValid || wait"
                    color="warning"
                    class="mr-4"
                    @click="save"
                  >
                    Vystavit dobropis
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  name: 'CreateCreditNoteForm',
  mixins: [rules],
  data () {
    return {
      maxAmount: -1,
      wait: false,
      dialog: false,
      creditError: false,
      errorMessage: '',
      form: {
        user: {},
        amount: 0,
        comment: null,
        all: false
      },
      dataChecked: false,
      formValid: true,
      users: []
    }
  },
  created () {
    this.$http.get('/admin/roles/6', { params: { slim: 1, with_credit: 1 } })
      .then(response => {
        this.users = this.keysToCamelCase(response.data)
          .map(user => ({ ...user, name: `${user.firstName} ${user.lastName}, ${user.email}` }))
      })
  },
  methods: {
    save () {
      this.wait = true
      this.$http.post('admin/transactions/credit-notes',
        this.keysToSnakeCase({
          ...this.form,
          user: null,
          userId: this.form.user.id
        }))
        .then(() => {
          this.wait = false
          this.$emit('data-saved')
        })
        .catch(err => {
          this.wait = false
          if (err.response.status === 400) {
            this.creditError = true

            if (err.response.data && err.response.data.message === 'Credit error') {
              this.errorMessage = 'Uživatel nemá dostatek kreditu.'
            } else {
              this.errorMessage = 'Dobropis se nepodařilo vytvořit.'
            }
            setTimeout(() => { this.noCreditError = false }, 3500)
          }
        })
    }
  },
  computed: {
    hasCredit () {
      const credit = this.form.user && this.form.user.credit
      return credit != null && credit > 0
    }
  },
  watch: {
    'form.user': function (newVal) {
      const credit = newVal && newVal.credit != null ? newVal.credit : 0
      this.maxAmount = credit > 0 ? credit : 0
      this.form.all = false
      if (this.$refs.amount) {
        this.$refs.amount.reset()
      }
      if (this.$refs.check) {
        this.$refs.check.reset()
      }
    },
    'form.all': function (val) {
      if (val) {
        this.form.amount = this.maxAmount
      }
    },
    'form.amount': function (val) {
      if (val > this.maxAmount) {
        this.form.amount = this.maxAmount
      }
      if (+val === this.maxAmount) {
        this.form.all = true
      }
    }
  }
}
</script>

<style scoped>

</style>
